/* eslint-disable */
export default {
  _Are_you_ready_to_serve_: 'Are_you_ready_to_serve_',
  _Burp_Excuse_Me: 'Burp_Excuse_Me',
  _Cone_Container: 'Cone_Container',
  _Make_an_Ice_Cream: 'Make_an_Ice_Cream',
  _Ooooo_Ice_Cream: 'Ooooo_Ice_Cream',
  _Sauce: 'Sauce',
  _Slide_Down_Counter: 'Slide_Down_Counter',
  _Toppings: 'Toppings',
  _What_Flavor: 'What_Flavor',
  _Whipped_Cream: 'Whipped_Cream',
}